import { Link } from "react-router-dom";

const AccommodationCTA = () => {
  const features = [
    { icon: "ri-hotel-line", title: "Otel & Pansiyon", desc: "Tüm konaklama türleri için üyelik" },
    { icon: "ri-phone-line", title: "Telefon ile Rezervasyon", desc: "Ziyaretçiler sizi doğrudan arasın" },
    { icon: "ri-shield-check-line", title: "Admin Onaylı", desc: "Güvenilir işletmeler listesi" },
    { icon: "ri-map-pin-line", title: "Harita Görünümü", desc: "Konumunuz haritada gösterilsin" },
  ];

  return (
    <section className="py-20 bg-stone-900 relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Turkey%20luxury%20hotel%20rooftop%20terrace%20panoramic%20view%20Istanbul%20Bosphorus%20sunset%20warm%20golden%20hour%20elegant%20outdoor%20seating%20beautiful%20scenery&width=1400&height=600&seq=acc-cta-home-bg&orientation=landscape"
          alt="Konaklama"
          className="w-full h-full object-cover object-top opacity-15"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-stone-900/95 via-stone-900/80 to-stone-900/60"></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* Left: Text */}
          <div>
            <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-5 uppercase tracking-widest">
              İşletme Üyeliği
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Otelinizi veya Pansiyonunuzu<br />
              <span className="text-amber-400">Binlerce Gezgine</span> Tanıtın
            </h2>
            <p className="text-stone-300 text-sm leading-relaxed mb-6 max-w-lg">
              Türkiye Seyahat Rehberi'ne üye olun. Otel, pansiyon, butik otel veya turizm firmanızı listeleyin. Ziyaretçiler sizi haritada bulsun, telefon ile doğrudan arasın, rezervasyon yapsın.
            </p>

            {/* Feature list */}
            <div className="grid grid-cols-2 gap-3 mb-8">
              {features.map((f) => (
                <div key={f.title} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-amber-500/20 rounded-lg flex-shrink-0 mt-0.5">
                    <i className={`${f.icon} text-amber-400 text-sm`}></i>
                  </div>
                  <div>
                    <p className="text-white text-xs font-semibold">{f.title}</p>
                    <p className="text-stone-400 text-xs mt-0.5">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-3">
              <Link
                to="/hotel-apply"
                className="flex items-center gap-2 px-6 py-3 bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-building-2-line"></i>
                Ücretsiz Üyelik Başvurusu
              </Link>
              <Link
                to="/accommodations"
                className="flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 border border-white/20 text-white text-sm font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-eye-line"></i>
                Konaklama Rehberini Gör
              </Link>
            </div>
          </div>

          {/* Right: Stats + Cards */}
          <div className="space-y-4">
            {/* Stats row */}
            <div className="grid grid-cols-3 gap-3">
              {[
                { value: "150+", label: "Kayıtlı İşletme" },
                { value: "12K+", label: "Aylık Ziyaretçi" },
                { value: "4.8", label: "Ortalama Puan" },
              ].map((s) => (
                <div key={s.label} className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-2xl p-4 text-center">
                  <p className="text-2xl font-bold text-amber-400" style={{ fontFamily: "'Playfair Display', serif" }}>{s.value}</p>
                  <p className="text-stone-400 text-xs mt-1">{s.label}</p>
                </div>
              ))}
            </div>

            {/* Sample business cards */}
            {[
              {
                name: "Kapadokya Cave Suites",
                type: "Butik Otel",
                city: "Nevşehir · Göreme",
                price: "₺₺₺",
                rating: "4.9",
                phone: "0384 271 22 00",
                color: "bg-rose-100 text-rose-700",
              },
              {
                name: "Ölüdeniz Blue Bay Hotel",
                type: "Otel",
                city: "Muğla · Ölüdeniz",
                price: "₺₺₺",
                rating: "4.8",
                phone: "0252 617 00 55",
                color: "bg-amber-100 text-amber-700",
              },
            ].map((card) => (
              <div key={card.name} className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-2xl p-4 flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-xl flex-shrink-0">
                  <i className="ri-hotel-line text-amber-400 text-xl"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${card.color}`}>{card.type}</span>
                    <span className="flex items-center gap-0.5 text-xs text-amber-400 font-semibold">
                      <i className="ri-star-fill text-xs"></i> {card.rating}
                    </span>
                  </div>
                  <p className="text-white font-semibold text-sm leading-snug">{card.name}</p>
                  <p className="text-stone-400 text-xs">{card.city} · {card.price}</p>
                </div>
                <a
                  href={`tel:${card.phone}`}
                  className="flex items-center gap-1.5 px-3 py-2 bg-emerald-500/20 hover:bg-emerald-500/40 border border-emerald-500/30 text-emerald-400 text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
                >
                  <i className="ri-phone-fill"></i> Ara
                </a>
              </div>
            ))}

            {/* CTA mini */}
            <Link
              to="/hotel-apply"
              className="flex items-center justify-between w-full p-4 bg-amber-500/10 hover:bg-amber-500/20 border border-amber-500/30 rounded-2xl transition-colors cursor-pointer group"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-500/20 rounded-xl">
                  <i className="ri-add-circle-line text-amber-400 text-lg"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-semibold">İşletmenizi Ekleyin</p>
                  <p className="text-stone-400 text-xs">Ücretsiz · Admin onaylı · Hemen başlayın</p>
                </div>
              </div>
              <i className="ri-arrow-right-line text-amber-400 group-hover:translate-x-1 transition-transform"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AccommodationCTA;
